import React, { Component } from 'react';
import KickImage from 'Reuseables/KickImage';
import {
    Modal,
    ModalHeader,
    ModalBody,
    Container,
    Row,
    Col } from 'reactstrap';
import { Button } from '../Forms';
import { connect } from 'react-redux';
import { doSentLinkVerificationEmail, doRefreshToken, doFetchProfile } from '../../actions/authAction';

class ModalNotVerified extends Component{
    constructor(props){
        super(props);

        this.state = {
            errorMessage: null,
            isSubmittingVerif: false
        }

        this._onSentEmail = this._onSentEmail.bind(this);
    }

    componentDidUpdate(prevProps){
        if(prevProps.userData.isFetch !== this.props.userData.isFetch && !this.props.userData.isFetch){
            if(this.props.userData.status_code === 200){
                const unverifiedUser = this.props.userData.roles.includes("unverified_user")

                if(unverifiedUser){
                    this.setState({ errorMessage: "Please check your email and click the verification link in it." })
                }
            } else {
                this.setState({ errorMessage: this.props.userData.error })
            }
        }
    }

    _onSentEmail(){
        this.props.submit();
        setTimeout(()=>{
            if(this.props.isOpen===true)
                this.props.onToggle();
            this.props.onSuccess();
        },300)
    }

    onCheckVerified = () => {
        this.setState({ isSubmittingVerif: true, errorMessage: null });

        this.props.doRefreshToken()
        .then((res) => {
            this.setState({ isSubmittingVerif: false, errorMessage: null });
            this.props.doFetchProfile();
        })
        .catch((e) => {
            this.setState({ isSubmittingVerif: false, errorMessage: e });
        })
    }

    renderUnverified = () => (
        <>
            <ModalHeader toggle={this.props.onToggle}></ModalHeader>
            <ModalBody>
                <Container>
                    <KickImage src="/images/shoe-cartoon.png" alt="shoe-cartoon"/>
                    <h5>{this.props.email}</h5>
                    <p> Attention, your email has not been verified. Please check your inbox / junk / spam for an email from no-reply@kickavenue.com and click the verification link in it. </p>
                    <Row>
                        <Col xs={12} md={{size:8,offset:2}} >
                            <Button className="btn-green bold btn-send-verify" disabled={this.props.data.isSubmit} loadingText="LOADING..." onClick={this._onSentEmail} buttonText="SEND EMAIL VERIFICATION" block size="lg"/>
                        </Col>
                    </Row>
                    <Row>
                        <Col xs={12} md={{size:8,offset:2}} >
                            <Button className="btn-white bold btn-send-verify" disabled={this.state.isSubmittingVerif} loadingText="SUBMITTING..." onClick={this.onCheckVerified} buttonText="I'M VERIFIED" block size="lg"/>
                        </Col>
                    </Row>
                    <p className="error-message">{this.state.errorMessage}</p>
                </Container>
            </ModalBody>
        </>
    )

    render(){
        return(
            <Modal isOpen={this.props.isOpen} toggle={this.props.onToggle} className="kick-modal modal-not-verified">
                {this.renderUnverified()}
            </Modal>
        )
    }
}

const mapStateToProps = ({dataAuth:{ userSentLinkEmailVerify, userdata, refreshTkn }})=>({
    data: userSentLinkEmailVerify,
    userData: userdata,
    refreshToken: refreshTkn
})

const mapDispatchToProps = dispatch =>({
    submit : ()=> dispatch(doSentLinkVerificationEmail()),
    doRefreshToken: () => dispatch(doRefreshToken()),
    doFetchProfile: () => dispatch(doFetchProfile())
})

export default connect(mapStateToProps,mapDispatchToProps)(ModalNotVerified);
